<script>
    import "../../../../app.css";
    import HowItWorksItem from "./HowItWorksItem.svelte";
    import { t } from "$lib/i18n.js";
</script>

<section>
    <div class="steps">
        <h3>{$t('routes.home.steps_title')}</h3>

        <div class="arrows arrow-top">
            <img src="https://assets.auting.it/images/arrows/water-green/top/arrow.svg" alt="Arrow" />
        </div>
        <div class="items">
            <HowItWorksItem icon='🔍' headline="{$t('routes.home.steps.1')}" />
            <HowItWorksItem icon='💬' headline="{$t('routes.home.steps.2')}" />
            <HowItWorksItem icon='🌟' headline="{$t('routes.home.steps.3')}" />    
            <HowItWorksItem icon='💙' headline="{$t('routes.home.steps.4')}" />
        </div>
        <div class="arrows arrows-bottom">
            <img src="https://assets.auting.it/images/arrows/water-green/bottom/arrow_1.svg" alt="Arrow" />
            <img src="https://assets.auting.it/images/arrows/water-green/bottom/arrow_2.svg" alt="Arrow" />
        </div>
    </div>

</section>

<style>
    section {
        padding-top: 150px;
        padding-bottom: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 40px;
        background-color: var(--surface-container-50);
    }

    h2 {
        margin: 0;
        padding: 0;
        text-align: center;
        color: var(--on-surface);
        font-family: var(--font-body);
    }

    h3 {
        margin: 0 0 2rem 0;
        text-align: center;
        color: var(--on-surface-50);
    }

    .steps {
        max-width: var(--max-width);
        width: 100%;
        gap: 0px;
    }

    .steps .arrow-top {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 40px;
    }

    .steps .items {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        gap: 40px;
        margin-top: 40px;
    }

    .steps .arrows-bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin-top: 0px;
        height: 80px;
    }

    @media (max-width: 768px) {
        section {
            padding-top: 100px;
            padding-bottom: 80px;
            gap: 24px;
        }

        h2 {
            font-size: 32px;
        }

        .steps .arrow-top,
        .steps .arrows-bottom {
            height: 60px;
            display: none;
        }

        .steps .items {
            flex-direction: column;
            align-items: center;
            gap: 10px;
        }
    }
</style>
